import React, { useState, useEffect } from "react";
import { useAuth } from "../AuthContext";
//import axios from "axios";
import AddLog from "./AddLog"; // ✅ 로그 저장 함수 가져오기

import "../styles/UserRegisterModal.css"; // CSS 파일 import

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; 

const GovernmentRegisterModal = ({ onClose, onGovernmentAdded }) => {
    const { user } = useAuth();    
    const [isIdValid, setIsIdValid] = useState(false); // 중복 여부 확인

    const [governmentCode, setGovernmentCode] = useState("");
    //const [userId, setUserId] = useState("");    
    //const [userType, setUserType] = useState("U");
    const [governmentName, setGovernmentName] = useState("");    
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    

    // 페이지가 로드될 때 관공서 코드 생성
    useEffect(() => {
        const generateGovernmentCode = () => {
            const currentDate = new Date();
            const year = currentDate.getFullYear().toString().slice(2);  // '25' (현재 연도)
            const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');  // '02' (현재 월)
            const day = currentDate.getDate().toString().padStart(2, '0');  // '18' (현재 일)
            const randomNum = Math.floor(Math.random() * 99) + 1;  // 01~99 랜덤 숫자
            const formattedRandomNum = randomNum.toString().padStart(2, '0');  // '04' 형식으로 맞추기

            return `G${year}${month}${day}${formattedRandomNum}`;  // 'G25021804' 형식
        };

        setGovernmentCode(generateGovernmentCode());
    }, []);  // 컴포넌트 마운트 시 한 번만 실행

    

    // 관공서코드 중복 확인
    const handleCheckDuplicate = async () => {
        const trimmedPcode = governmentCode.trim();

        if (!(trimmedPcode.length === 9 && trimmedPcode.startsWith("G"))) {
            alert("관공서코드는 G로 시작하는 9자를 입력해야됩니다.");
            //setIdMessage("ID를 입력해 주세요.");
            setIsIdValid(false);
            return;
        }

        try {            
            const response = await fetch(`${API_BASE_URL}/api/Government/check-duplicate?governmentCode=${trimmedPcode}`);
            const data = await response.json();

            if (data.exists) {
                alert("이미 사용 중인 관공서코드입니다.");
                //setIdMessage("이미 사용 중인 ID입니다.");
                setIsIdValid(false);
            } else {
                alert("사용 가능한 관공서코드입니다.");
                //setIdMessage("사용 가능한 ID입니다.");
                setIsIdValid(true);
            }
        } catch (error) {
            //console.error("ID 중복 확인 오류:", error);
            alert("중복 확인 중 오류가 발생했습니다.");
            //setIdMessage("중복 확인 중 오류가 발생했습니다.");
            setIsIdValid(false);
        }
    };

    // 카카오 주소 검색
    const handleSearchAddress = () => {
        new window.daum.Postcode({
            oncomplete: (data) => {
                // 주소를 DB에 저장
                setAddress1(data.address);
            },
            width: 500, // 창 너비
            height: 600, // 창 높이
        }).open({
            left: (window.screen.width / 2) - 250,  // 중앙 정렬 (화면 너비 기준)
            top: (window.screen.height / 2) - 300   // 중앙 정렬 (화면 높이 기준)
        });
    };

    // 저장 버튼 클릭
    const handleSave = async () => { // 'async' 추가
        
        if (!(governmentCode.length === 9 && governmentCode.startsWith("G"))) {
            alert("관공서코드는 G로 시작하는 9자를 입력해야됩니다.");
            setTimeout(() => {
                document.getElementsByName("governmentCode")[0].focus();
            }, 0);
            return;
        }
        else if (!isIdValid) {
            alert("관공서코드 중복확인을 해주세요!");
            setTimeout(() => {
                document.getElementsByName("governmentCodebt")[0].focus();
            }, 0);
            return;
        }
        else if (!governmentName.trim()) {
            alert("관공서명을 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("governmentName")[0].focus();
            }, 0);
            return;
        }        
        else if (!address1.trim() ) {
            alert("주소검색으로 기본주소를 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("location1bt")[0].focus();
            }, 0);
            return;
        }
        else if (!address2.trim() ) {
            alert("나머지 주소를 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("location2")[0].focus();
            }, 0);
            return;
        }

        
        const newGovernment = {
            GovernmentCode: governmentCode,
            GovernmentName: governmentName.trim(),
            Address1: address1,
            Address2: address2.trim(),            
        };

        //console.log("신규 사용자 정보:", JSON.stringify(newUser, null, 2));
        //alert(newUser.userId);

        try {
            
            const response = await fetch(`${API_BASE_URL}/api/Government/add-government`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newGovernment),
            });

            const data = await response.json();
            if (response.ok) {

                await AddLog(user.userId, "", newGovernment.GovernmentCode, "7-1");

                alert("관공서 등록이 완료되었습니다.");
                onGovernmentAdded();  // 리스트 갱신을 요청하는 콜백 호출
                onClose();
            } else {
                alert("관공서 등록에 실패했습니다: " + data.message);
                //console.log("응답 상태 코드:", response.status);
                //console.log("서버 응답 데이터:", data);
            }
            
        } catch (error) {
            //console.error("오류:", error);
            alert("관공서 등록 중 오류가 발생했습니다.");
        }
       
        onClose();
    };

    return (
        <div className="modal-overlay2">
            <div className="modal-content2">
                {/* 모달 헤더 */}
                <div className="modal-header">
                    <h2>관공서 신규 등록</h2>
                    <button className="modal-close-btn" onClick={onClose}><i className="fa fa-times-circle"></i></button>
                </div>

                {/* 입력 필드 */}
                <div className="form-group2">
                    <label>관공서코드</label>
                    <div className="input-group2">                        
                        <input
                            name="governmentCode"
                            type="text"
                            maxLength="9"
                            value={governmentCode}
                            onChange={(e) => setGovernmentCode(e.target.value.trim().toUpperCase())}
                            disabled={isIdValid} // isIdValid가 true이면 편집 불가
                            style={{ backgroundColor: isIdValid ? "Whitesmoke" : "white", textTransform: 'uppercase' }} // 배경색 변경
                        />

                        <button
                            name="governmentCodebt"
                            className={isIdValid ? "check-btn2" : "check-btn"}
                            onClick={handleCheckDuplicate}
                        >
                            <i className="fa fa-user"></i>
                        </button>
                    </div>
                    
                </div>

                <div className="form-group2">
                    <label>관공서명</label>
                    <div className="input-group2">
                        <input name="governmentName" type="text" maxLength="18" value={governmentName} onChange={(e) => setGovernmentName(e.target.value)} />
                    </div>
                </div>                              

                <div className="form-group2">
                    <label>소재지1</label>
                    <div className="input-group2">
                        <input type="text" readOnly value={address1} />
                        <button name="location1bt" className="search-btn" onClick={handleSearchAddress}><i className="fa fa-search"></i></button>
                    </div>
                </div>

                <div className="form-group2">
                    <label>소재지2</label>
                    <div className="input-group2">
                        <input name="location2" type="text" maxLength="40" value={address2} onChange={(e) => setAddress2(e.target.value)} />
                    </div>
                </div>


                {/* 저장 버튼 */}
                <button className="save-btn" onClick={handleSave}>저장</button>
            </div>
        </div>
    );
};

export default GovernmentRegisterModal;
